import "./TrophyDescriptionComponent.css";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaTrophy } from "react-icons/fa";
import { Tooltip } from "react-tooltip";


function TrophyDescriptionComponent({
  index,
  title,
  qualification,
  imgUrl,
  completed,
  description,
}) {
  return (
    <div>
    
    <div className="trophy-card" data-tooltip-id={`trophy-card-${index}`}>
      <div className="main-info-container">
        {/* <img src={imgUrl} alt={title} className="trophy-card-img" /> */}
        <div className="trophy-card-content">
          <h2 className="trophy-card-title">
            <FaTrophy style={{ color: "gold", fontSize: "17px"}}/> {title}
          </h2>
          <p className="trophy-card-description">{qualification}</p>
        </div>
      </div>
      {completed && (
        <div className="completion-status-container">
          <span style={{ color: "green" }}>Earned</span>{" "}
          <AiOutlineCheckCircle style={{ color: "green" }} />
        </div>
      )}
      </div>
      <Tooltip id={`trophy-card-${index}`} style={{ maxWidth: "min(90vw, 420px)"}}>{description != undefined ? description : ""}</Tooltip>
      
    </div>
    
    
  );
}

export default TrophyDescriptionComponent;
